import {TextEntity} from "@/entity/TextEntity";
import {ImageEntity} from "@/entity/ImageEntity";

export class BasketContextDataEntity{
    texts:TextEntity[] = [];
    images:ImageEntity[] = [];
}